import { _, api, helpers, ts } from '_core';

type DataSourceApiResponse = {
  data: ts.types.dataSource.DataSource;
};

export const createDataSource = async (
  newData: ts.types.dataSource.DataSourceDraft,
  callback: (_data: ts.types.dataSource.DataSource) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: DataSourceApiResponse = await api.data_sources.create(newData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error creating data source - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateDataSource = async (
  id: number,
  newData: ts.types.dataSource.DataSourceDraft,
  callback: (_data: ts.types.dataSource.DataSource) => void,
  errorCallback: (_error: string) => void,
  increment = false
) => {
  try {
    const resp: DataSourceApiResponse = increment
      ? await api.data_sources.increment(id, { ...newData })
      : await api.data_sources.update(id, { ...newData });

    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating data source - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateDefinition = async (
  id: number,
  definition: ts.types.dataSource.DataSourceDraft,
  callback: (_data: ts.types.dataSource.DataSource) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp = await api.data_sources.update(id, definition, true);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the definition - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const getDataSource = async (id: number, userId: number) => {
  const resp = await api.data_sources.get(id);
  const respExtra = await api.uiApi.getDataSourceData({
    data: {
      handle: resp.data.handle,
      ignore_cache: true,
    },
  });
  const ds = {
    ...resp.data,
    ui_metadata: _.isEmpty(resp.data.ui_metadata) ? {} : resp.data.ui_metadata,
  };

  return {
    dataSource: {
      ...ds,
      shared: !ds.is_published && ds.shared_with.includes(userId) && ds.created_by_id !== userId,
    },
    prevHtml: respExtra.preview_html,
  };
};
